<template>
  <div class="inner-box">
    <form>
      <div class="content-name">
        <h2 class="dp-ib">{{ title }}</h2>
        <div class="btn-wrap btn-type1 clearfix">
          <button v-if="this.$store.state.loginInfo.isSearchAll && boardCd !='22'" type="button" class="btn-size btn-blue fl_left" @click="goWrite()">
            <span class="btn-icon"><i class="far fa-file"></i></span>
            신규
          </button>
          <button v-if="!this.$store.state.loginInfo.isSearchAll && boardCd =='22'" type="button" class="btn-size btn-blue fl_left" @click="goWrite()">
            <span class="btn-icon"><i class="far fa-file"></i></span>
            등록
          </button>
          <button type="button" class="btn-size btn-gray fl_left" @click="getBoardList()">
            <span class="btn-icon"><i class="fas fa-search"></i></span>
            조회
          </button>
        </div>
      </div>
    </form>
    <div class="search-form" style="margin-bottom:20px;">
      <div class="form-group">
        <label class="control-label">게시일</label>
        <div class="form-input">
          <div class="datepicker w-type-ymd02">
            <dhx-calendar class="input ddate sDate" v-model="form.searchDtmFr" />
          </div>
          <span class="wave"> ~ </span>
          <div class="datepicker w-type-ymd02">
            <dhx-calendar class="input ddate sDate" v-model="form.searchDtmTo" />
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">제목/내용</label>
        <div class="form-input">
          <input type="text" class="input" v-model="form.searchCont"/>
        </div>
      </div>
            
    </div>
    <Tab v-if="boardMng.boardSubFlag=='Y'" :tab="tab" :active-btn="activeBtn" @changeTab="changeTab"/>
    <ListSaleSupportGuide v-if="boardCd=='11'" :board-list ="boardList" :title="title" :board-cd="boardCd"/>
    <ListNewsletter v-if="boardCd=='21'" :board-list ="boardList" :title="title" :board-cd="boardCd"/>
    <ListSuggest v-if="boardCd=='22'" :board-list ="boardList" :title="title" :board-cd="boardCd"/>
        
  </div>
</template>

<script>
import Tab from '@/components/Tab.vue';
import ListSaleSupportGuide from '@/components/Bbs/ListSaleSupportGuide.vue';
import ListNewsletter from '@/components/Bbs/ListNewsletter.vue';
import ListSuggest from '@/components/Bbs/ListSuggest.vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';

export default {
    name:'BoardList',
    components:{Tab, ListSaleSupportGuide, ListSuggest, ListNewsletter, DhxCalendar},
    props:{
        title:{
            type:String,
            required: true
        },
        boardCd:{
            type:String,
            required: true
        }
    },
    data(){
        return {
            tab:[
                {tabName:'전체', tabCss:"btn btn-primary", tabNo:'0'},
                {tabName:'', tabCss:"btn btn-outline-primary", tabNo:'1'},
                {tabName:'', tabCss:"btn btn-outline-primary", tabNo:'2'},
                {tabName:'', tabCss:"btn btn-outline-primary", tabNo:'3'},
            ],
            activeBtn:true, /**  true면 버튼 활성화*/
            form: {
                searchDtmFr: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
                searchDtmTo: this.$moment().format('YYYY-MM-DD'),
                searchCont:''
            },
            boardMng:{},
            boardSubCd:'',
            boardList:[],
            subList:[],
                    
        }
    },
    mounted(){
        this.getMenu();
        this.getBoardList();
        
    },
    methods: {
        /** 탭 페이지 이동(동적 컴포넌트 활용) */
        changeTab(no){
            switch(no){
                case '0':
                    this.boardSubCd = ''
                    this.getBoardList();
                    break;
                case '1':
                    this.boardSubCd = '11A'
                    this.getBoardList();
                    break;
                case '2':
                    this.boardSubCd = '11B'
                    this.getBoardList();
                    break;
                case '3':
                    this.boardSubCd = '11C'
                    this.getBoardList();
                    break;
            }
        },
        getMenu(){
            this.$http.get(`/api/board/`+ this.boardCd)
            .then(response => {
                this.boardMng=response.data;
                if(this.boardMng.boardSubFlag=='Y'){
                    this.getBoardSubList();
                }
            })
        },
        getBoardList(){
            this.$http.get(`/api/board/boardList`,{
                params:{
                    searchDtmFr: this.form.searchDtmFr,
                    searchDtmTo:this.form.searchDtmTo,
                    searchCont:this.form.searchCont,
                    boardCd:this.boardCd,
                    boardSubCd:this.boardSubCd,
                }
            })
            .then(response => {
                this.boardList=response.data;
            })
        },
        getBoardSubList(){
            this.$http.get(`/api/board/boardSubMenu`)
            .then(response=>{
                this.subList=response.data;
                for(let i=0; i<this.subList.length; i++){
                    this.tab[i+1].tabName = this.subList[i].detailNm;
                }
            })
        },
        goWrite(){
            this.$router.push({          
                name: 'boardWrite',
                params: {
                    title : this.title,
                    boardCd : this.boardCd 
                }
            })
            const boardInfo={};
            boardInfo.title = this.title
            boardInfo.boardCd = this.boardCd
            this.$store.commit('boardCd', boardInfo)
        }
        
    },
    

    
}
</script>